import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { PencilIcon } from "@/components/developer/DashboardIcons";

interface Education {
  id: string;
  institution: string;
  degree: string;
  field_of_study: string;
  start_date: string;
  end_date?: string | null;
}

interface EducationListProps {
  educations: Education[];
  onEdit: (education: Education) => void;
}

const EducationList = ({ educations, onEdit }: EducationListProps) => {
  const getYear = (dateString?: string | null) => {
    if (!dateString) return null;
    return new Date(dateString).getFullYear();
  };

  return (
    <div className="space-y-6">
      {educations.map((education) => (
        <div key={education.id} className="group relative">
          <div className="flex justify-between mb-2">
            <div>
              <h3 className="font-semibold">{education.institution}</h3>
              <p className="text-sm text-gray-600">
                {education.degree} in {education.field_of_study}
              </p>
            </div>
            <div className="flex items-start gap-2">
              <p className="text-sm text-gray-600">
                {getYear(education.start_date)} -{" "}
                {education.end_date ? getYear(education.end_date) : "Present"}
              </p>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(education)}
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EducationList;